import React from "react";
import styled from "styled-components";
import { Input, ConfigProvider } from "antd";

const theme = {
  components: {
    Input: {
      activeBorderColor: "var(--aia-bx-blue-2)",
      hoverBorderColor: "var(--aia-bx-blue-2)",
    },
  },
};

const FormInput = ({ children, prefix, suffix, value, handleChange, ...props }) => {
  return (
    <ConfigProvider theme={theme}>
      <InputText size="large" prefix={prefix} suffix={suffix} value={value} onChange={handleChange} {...props} allowClear />
    </ConfigProvider>
  );
};

const InputText = styled(Input)`
  border: 1px solid var(--aia-bx-gray-5);
  border-radius: 100px;
  font-size: 16px;
  width: 100%;
  outline-color: var(--aia-bx-blue-2);
  padding: 10px 16px;
  align-items: center;

  ::placeholder {
    color: var(--aia-bx-gray-2);
  }

  :-webkit-autofill,
  :-webkit-autofill:hover, 
  :-webkit-autofill:focus, 
  :-webkit-autofill:active  {
    transition: background-color 5000s;
  }

  &:hover, &:focus {
    box-shadow: 0px 0px 0.5rem 0px rgba(2, 114, 174, 0.2);
  }
`;

export default FormInput;